import React from 'react';

import type { Stripe } from '@stripe/stripe-js';

const StripeContext = React.createContext<Promise<Stripe | null> | null>(null);

export default StripeContext;
